import { configureStore } from '@reduxjs/toolkit';

import adminApi from '@/store/services/adminApi';
import audiencesApi from '@/store/services/audiencesApi';
import authApi from '@/store/services/authApi';
import leadsApi from '@/store/services/leadsApi';

const buildStore = () =>
    configureStore({
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(
                adminApi.middleware,
                audiencesApi.middleware,
                authApi.middleware,
                leadsApi.middleware,
            ),
        reducer: {
            [adminApi.reducerPath]: adminApi.reducer,
            [audiencesApi.reducerPath]: audiencesApi.reducer,
            [authApi.reducerPath]: authApi.reducer,
            [leadsApi.reducerPath]: leadsApi.reducer,
        },
    });

const store = buildStore();

export { buildStore };
export default store;
